import React, { useEffect } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./Main.css";
import * as routes from "../../routes";
import withAuthentication from "../common/withAuthentication";
import { loadConfiguration } from "../../redux/configuration/actions";
import { initializeIdentityProvider } from "../../redux/authentication/actions";
import { AppBar, Box } from "@material-ui/core";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import HomePage from "../Home/HomePage";
import AboutPage from "../About/AboutPage";
import AppDownloader from "../AppDownloader/AppDownloader";
import PbiReportsLayout from "../EmbeddedPbiReports/ReportsLayout";
import PageNotFound from "../common/PageNotFound";
import WaitCursor from "../common/WaitCursor";
import { loadReportsforUsers } from "../../redux/embeddedpbireports/actions";

const Main = () => {
    const dispatch = useDispatch();
    const configuration = useSelector(state => state.configuration);
    const authentication = useSelector(state => state.authentication);

    useEffect(() => {
        if (authentication.account && !authentication.isLoggingIn) {
            if (configuration.enableEmbeddedPowerBi) {
                dispatch(loadReportsforUsers());
            }
        }
    }, [authentication.account, authentication.isLoggingIn]);

    useEffect(() => {
        dispatch(loadConfiguration());
    }, [dispatch]);

    useEffect(() => {
        const { clientId, authority } = configuration;

        if (clientId && authority) {
            dispatch(initializeIdentityProvider(clientId, authority));
        }
    }, [configuration, dispatch]);

    return !configuration.clientId ? (
        <WaitCursor />
    ) : (
        <Box className="container">
            <AppBar enableColorOnDark position="static">
                <Header />
            </AppBar>
            <Box className="content">
                <Switch>
                        <Route exact path={routes.DEFAULT} component={HomePage} />
                        <Route
                            path={routes.DCA_INSTALLER}
                            render={props => (
                                    <AppDownloader installee="dca" languageIsSelectable platformIsSelectable {...props} />
                            )}
                        />
                        <Route
                            path={routes.CONTROL_PANEL_INSTALLER}
                            render={props => <AppDownloader installee="controlPanel" languageIsSelectable platformIsSelectable {...props} />}
                        />
                        <Route path={routes.ABOUT} component={AboutPage} />
                        <Route
                            path={routes.CONTROL_PANEL_UPGRADE}
                            component={
                                (authentication.account && !authentication.isLoggingIn)
                                    ?
                                    ((props) => <AppDownloader installee="controlPanelUpgrade" languageIsSelectable platformIsSelectable showMessage {...props} />)
                                    :
                                    (() => <Redirect to={routes.DEFAULT} />)
                            }
                        />
                        <Route
                            path={routes.EMBEDDED_POWER_BI}
                            component={(configuration.enableEmbeddedPowerBi) ? withAuthentication(PbiReportsLayout) : (() => <Redirect to={routes.DEFAULT} />)}
                        />
                        <Route component={PageNotFound} />
                </Switch>

            </Box>
            <Box class="footer-content">
                <Footer  />
            </Box>
        </Box>
    );
};

export default Main;
